import { Filter } from '../reportingTypes';
import { dateToISOString } from './formatting';

/**
 * Get default values for all filters
 */
export const getDefaultFilterValues = (
  filters: Filter[]
): Record<string, unknown> => {
  const defaults: Record<string, unknown> = {};

  filters.forEach((filter) => {
    if (filter.defaultValue !== null && filter.defaultValue !== undefined) {
      defaults[filter.id] = filter.defaultValue;
    } else {
      // Set sensible defaults based on type
      switch (filter.type) {
        case 'multiSelect':
          defaults[filter.id] = [];
          break;
        case 'number':
          defaults[filter.id] = '';
          break;
        case 'text':
          defaults[filter.id] = '';
          break;
        case 'date':
          defaults[filter.id] = '';
          break;
        case 'select':
          defaults[filter.id] = filter.options?.[0]?.value || '';
          break;
        default:
          defaults[filter.id] = '';
      }
    }
  });

  return defaults;
};

/**
 * Convert form values to API format
 */
export const convertFiltersToApiFormat = (
  values: Record<string, unknown>
): Record<string, unknown> => {
  const apiFilters: Record<string, unknown> = {};

  Object.keys(values).forEach((key) => {
    const value = values[key];

    // Skip null/undefined values
    if (value === null || value === undefined) {
      return;
    }

    // Skip empty arrays
    if (Array.isArray(value) && value.length === 0) {
      return;
    }

    // Convert dates to ISO strings
    if (value instanceof Date) {
      apiFilters[key] = dateToISOString(value);
    } else {
      apiFilters[key] = value;
    }
  });

  return apiFilters;
};

/**
 * Check if all required filters are filled
 */
export const areRequiredFiltersFilled = (
  filters: Filter[],
  values: Record<string, unknown>
): boolean => {
  return filters.every((filter) => {
    // Skip non-required filters
    if (!filter.required) {
      return true;
    }

    // Skip hidden and system filters
    if (filter.hidden || filter.source === 'system') {
      return true;
    }

    const value = values[filter.id];

    if (value === null || value === undefined || value === '') {
      return false;
    }

    if (Array.isArray(value) && value.length === 0) {
      return false;
    }

    return true;
  });
};
